// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dnHO","newExpiryDate":"styles_newExpiryDate__gud7o","footer":"styles_footer__3R343"};